import { FeaturesState, getFeaturesState } from '@ipreo/northstar';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';

export class AppErrorComponent {
  constructor(protected store: Store) {}

  public messageBasedOnState$ = this.store.select(getFeaturesState).pipe(
    filter((state: FeaturesState) => state.loaded),
    map((state: FeaturesState) => {
      if (!state.loaded) {
        return 'Loading...';
      }
      switch (true) {
        case state.error:
          return 'An error occurred while fetching features.';
        case !state.routes || state.routes.length === 0:
        case !state.navigation || state.navigation.length === 0:
          return 'You do not have access to any applications. Please contact support.';
        case !state.defaultRoute || state.defaultRoute === '':
          return 'Warning! Default route is not set or is empty.';
        default:
          return '404: page missing';
      }
    })
  );
}
